
import React, { useEffect, useState, useRef } from "react";

import TableCapexDashboard, {
  TableCapexDashboardAdv,
} from "../../../common/TableCapexDashboard";
import { useDispatch, useSelector } from "react-redux";
import {
  CapexDashboardData,
  CapexDashboardData2,
  CapexDashboardData3,
} from "../../../common/config";
import {
  CapexListReducerAction,
  CapexListReducerAction2,
  CapexListReducerAction3,
} from "../../../store/actions/createTicketManageFields";
// import { ExcelFile, ExcelSheet, ExcelColumn } from 'react-data-export';
// import * as XLSX from "xlsx";
import ReactHTMLTableToExcel from 'react-html-table-to-excel';


const CapexDashboard = () => {

  var tableToCsv = require("node-table-to-csv");

  let htmlTable =
    "<table>" +
    "<tr> <th>r1c1</th> <td>r1c2</td> <td>r1c3</td> </tr>" +
    "<tr> <th>r2c1</th> <td>r2c2</td> <td>r2c3</td> </tr>" +
    "<tr> <th>r3c1</th> <td>r3c2</td> <td>r3c3</td> </tr>" +
    "</table>";

  let csv = tableToCsv(htmlTable);

  console.log(csv, "tableToCsv");
  const dispatch = useDispatch();
  const [capexData, setCapexData] = useState([]);
  const tableDataRef = useRef({
    capexData: [],
    capexData2: [],
    capexData3: [],
  });

  // const [capexDataArray, setCapexDataArray] = useState([]);

  useEffect(() => {
    dispatch(CapexListReducerAction(CapexDashboardData));
    dispatch(CapexListReducerAction2(CapexDashboardData2));
    dispatch(CapexListReducerAction3(CapexDashboardData3));
  }, []);

  const data1 = useSelector((state) => {
    let data1 = state?.CommonResponse?.capexData;

    if (Array.isArray(data1)) {
      const headers = [
        {
          label: "ISSUE OWNER",
          accessor: "GC",
        },
        {
          label: "SITE ID",
          accessor: "site_id",
        },
        {
          label: "AGING",
          accessor: "aging",
        },
      ];

      const data = [];
      const footerData = {};
      data1.forEach((item) => {
        if (Array.isArray(item?.data)) {
          const obData = {
            ...item,
          };
          item.data.forEach((item_2) => {
            if (!headers.find(ele => ele.label === item_2?.category)) {
              headers.push({
                label: item_2?.category,
                accessor: item_2?.category?.toLowerCase(),
              });
            }
            obData[item_2?.category?.toLowerCase()] = item_2?.count;
            footerData[item_2?.category?.toLowerCase()] = footerData[
              item_2?.category?.toLowerCase()
            ]
              ? footerData[item_2?.category?.toLowerCase()] + item_2?.count
              : +item_2?.count;
          });

          delete obData?.data;
          footerData["total_count"] = footerData["total_count"]
            ? +footerData["total_count"] + item?.total_count
            : item?.total_count;

          data.push(obData);
        }
      });
      headers.push({
        label: "TOTAL",
        accessor: "total_count",
      });
      // data.push(footerData);

      console.log("headers => ", headers);
      tableDataRef.current.capexData = {
        headers,
        data,
        footerData,
        eatCol: 3,
      };
      console.log(
        tableDataRef.current.capexData,
        "tableDataRef.current.capexData "
      );
    }
  });

  const data2 = useSelector((state) => {
    let data2 = state?.CommonResponse?.capexData2;

    if (Array.isArray(data2)) {
      const headers = [
        {
          label: "ISSUE OWNER",
          accessor: "issue_owner",
        },
        {
          label: "SITE ID",
          accessor: "site_id",
        },
        {
          label: "GC",
          accessor: "GC",
        },
      ];

      const data = [];
      const footerData = {};

      data2.forEach((item) => {
        if (Array.isArray(item?.data)) {
          const obData1 = {
            ...item,
          };
          item.data.forEach((item_2) => {
            if (!headers.find(ele => ele.label === item_2?.category)) {
              headers.push({
                label: item_2?.category,
                accessor: item_2?.category?.toLowerCase(),
              });
            }
            obData1[item_2?.category?.toLowerCase()] = item_2?.count;
            footerData[item_2?.category?.toLowerCase()] = footerData[
              item_2?.category?.toLowerCase()
            ]
              ? footerData[item_2?.category?.toLowerCase()] + item_2?.count
              : +item_2?.count;
          });

          delete obData1?.data;
          footerData["total_count"] = footerData["total_count"]
            ? +footerData["total_count"] + item?.total_count
            : item?.total_count;

          data.push(obData1);
        }
      });

      headers.push({
        label: "TOTAL",
        accessor: "total_count",
      });

      // data.push(footerData);

      tableDataRef.current.capexData2 = {
        headers,
        data,
        footerData,
        eatCol: 3,
      };
      console.log(
        "tableDataRef.current.capexData2",
        tableDataRef.current.capexData2
      );
    }
  });

  // if (Array.isArray(data1)) {
  //   setCapexData(data1[0].data)
  //   console.log(capexData, "nibataunga");
  // }

  console.log("tableDataRef.current => ", tableDataRef.current);

  // table3

  const data3 = useSelector((state) => {
    let data3 = state?.CommonResponse?.capexData3;

    if (Array.isArray(data3)) {
      const headers = [
        {
          label: "ISSUE OWNER",
          accessor: "issue_owner",
        },
        {
          label: "GC",
          accessor: "GC",
        },
        {
          label: "SITE ID",
          accessor: "site_id",
        },
        {
          label: "AGING",
          accessor: "aging",
        },
      ];

      const data = [];
      const footerData = {};
      data3.forEach((item) => {
        if (Array.isArray(item?.data)) {
          const obData3 = {
            ...item,
          };
          item.data.forEach((item_2) => {
            if (!headers.find(ele => ele.label === item_2?.category)) {
              headers.push({
                label: item_2?.category,
                accessor: item_2?.category?.toLowerCase(),
              });
            }
            obData3[item_2?.category?.toLowerCase()] = item_2?.count;
            footerData[item_2?.category?.toLowerCase()] = footerData[
              item_2?.category?.toLowerCase()
            ]
              ? footerData[item_2?.category?.toLowerCase()] + item_2?.count
              : +item_2?.count;
          });

          delete obData3?.data;
          footerData["total_count"] = footerData["total_count"]
            ? +footerData["total_count"] + item?.total_count
            : item?.total_count;
          data.push(obData3);
        }
      });
      headers.push({
        label: "TOTAL",
        accessor: "total_count",
      });

      // data.push(footerData);

      // console.log("headers => ", headers);
      tableDataRef.current.capexData3 = {
        headers,
        data,
        footerData,
        eatCol: 3,
      };
      console.log(tableDataRef.current.capexData3, "jhdkhjsadjs");
    }
  });

  // if (Array.isArray(data1)) {
  //   setCapexData(data1[0].data)
  //   console.log(capexData, "nibataunga");
  // }

  console.log("tableDataRef.current => ", tableDataRef.current);

  // const data = [
  //   { id: 1, name: "John Doe", age: 25, email: "john@example.com" },
  //   { id: 2, name: "Jane Smith", age: 30, email: "jane@example.com" },
  //   { id: 3, name: "Bob Johnson", age: 28, email: "bob@example.com" },
  // ];

  // function ExportToExcel1(type, fn, dl) {
  //   var elt = document.getElementById("tbl_exporttable_to_xls1");
  //   var wb = XLSX.utils.table_to_book(elt, { sheet: "sheet1" });
  //   return dl
  //     ? XLSX.write(wb, { bookType: type, bookSST: true, type: "base64" })
  //     : XLSX.writeFile(wb, fn || "HCVendor/GC_count." + (type || "xlsx"));
  // }

  let CodeData =
    <TableCapexDashboard data={tableDataRef.current.capexData} /> +
    <TableCapexDashboard data={tableDataRef.current.capexData2} /> +
    <TableCapexDashboard data={tableDataRef.current.capexData3} />;
  console.log(CodeData, "CodeDataCodeData");



  return (
    <div>
      <div className="text-right-container">
          <div className="head">CAPEX DASHBOARD</div>
          <ReactHTMLTableToExcel
        
            id="test-table-xls-button"
            className="download-table-xls-button text-right "
            table="table-to-xls"
            filename="CapexDashboard"
            sheet="CapexDashboard"
            buttonText="Export" 
             />
        {/* <button
          onClick={ExportToExcel1}
          style={{
            float: "right",
            marginBottom: "10px",
            borderRadius: "10px",
            backgroundColor: "#143b64",
            padding: "7px",
            color: "white",
          }}
          name="Export"
        >
          Export
        </button> */}
      </div>
      <div>
        <TableCapexDashboard data={tableDataRef.current.capexData} />
        <TableCapexDashboard data={tableDataRef.current.capexData2} />
        <TableCapexDashboard data={tableDataRef.current.capexData3} />
      </div>

      <table id="table-to-xls" style={{ display: "none" }}>
        <TableCapexDashboardAdv data={tableDataRef.current.capexData} />
        <TableCapexDashboardAdv data={tableDataRef.current.capexData2} />
        <TableCapexDashboardAdv data={tableDataRef.current.capexData3} />
      </table>
    </div>
  );
};

export default CapexDashboard;